/**
 * The store a non-Associate Entry tool launches against. The single rule shared by
 * buildParams (the storeId on the tool URL) and the view-only selectors, so the shell's
 * view-only decision always matches the store the tool actually shows.
 *
 * - View-only tools prefer the store the user picked, so picking a store other than the
 *   one they scanned into opens that store read-only. Scan-in clears the picked store,
 *   so after a scan this falls back to the scanned-into store and the tool is editable.
 * - Every other tool keeps the scanned-into store first.
 */
export const getLaunchStoreId = (
    isViewOnlyTool: boolean,
    currentStoreId?: string,
    selectedStoreId?: string,
): string | undefined => (isViewOnlyTool
    ? selectedStoreId || currentStoreId
    : currentStoreId || selectedStoreId) || undefined
